export default {
  dialogueId: 'Id диалога',
  readTheDialogueBeforeEvaluation: 'Прочтите диалог, после чего оцените его',
  communicationQualitySurveyAnswerRules:
    '1 – абсолютно не согласен, 12 – абсолюьно согласен',
  survey: 'Опрос'
};
